// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 3.75 C1.5 2.65 2.4 1.75 3.5 1.75 L12.5 1.75 C13.6 1.75 14.5 2.65 14.5 3.75 L14.5 5 C14.5 6.1 13.6 7 12.5 7 L3.5 7 C2.4 7 1.5 6.1 1.5 5 Z',
  'M4.2 4.33 L4.3 4.33 L4.3 4.42 L4.2 4.42 Z',
  'M1.5 11 C1.5 9.9 2.4 9 3.5 9 L12.5 9 C13.6 9 14.5 9.9 14.5 11 L14.5 12.25 C14.5 13.35 13.6 14.25 12.5 14.25 L3.5 14.25 C2.4 14.25 1.5 13.35 1.5 12.25 Z',
  'M4.2 11.57 L4.3 11.57 L4.3 11.68 L4.2 11.68 Z',
];
